import { render, staticRenderFns } from "./LastSisUpdateDate.vue?vue&type=template&id=6daefdfd&scoped=true&"
import script from "./LastSisUpdateDate.vue?vue&type=script&lang=js&"
export * from "./LastSisUpdateDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6daefdfd",
  null
  
)

export default component.exports